/**
 * Utility to detect how the app is be    isDirectNextjs,
    currentPort,
    baseUrl,
  };accessed
 */

export interface AccessMethod {
  isDjangoProxy: boolean;
  isDirectNextjs: boolean;
  currentPort: string;
  baseUrl: string;
}

/**
 * Detect if we're being accessed via Django proxy or direct Next.js
 */
export function getAccessMethod(): AccessMethod {
  if (typeof window === 'undefined') {
    return {
      isDjangoProxy: false,
      isDirectNextjs: false,
      currentPort: '',
      baseUrl: '/api',
    };
  }

  const currentPort = window.location.port;
  const isDjangoProxy = currentPort === '8000' || currentPort === '';
  const isDirectNextjs = currentPort === '3000';

  // Determine the correct base URL
  const baseUrl = isDjangoProxy ? '/api' : (process.env.NEXT_PUBLIC_API_BASE_URL || '/api');

  return {
    isDjangoProxy,
    isDirectNextjs,
    currentPort,
    baseUrl,
  };
}

/**
 * Get the correct WebSocket URL for HMR based on access method
 */
export function getWebSocketUrl(): string {
  const accessMethod = getAccessMethod();
  
  if (accessMethod.isDjangoProxy) {
    // When accessed via Django proxy, HMR should connect to Next.js directly
    return `ws://localhost:3000/_next/webpack-hmr`;
  }
  
  // Default HMR connection
  return `ws://localhost:${accessMethod.currentPort}/_next/webpack-hmr`;
}

export default {
  getAccessMethod,
  getWebSocketUrl,
};
